import { render, staticRenderFns } from "./HomeCompanyMain.vue?vue&type=template&id=dbf69f8e&scoped=true&"
import script from "./HomeCompanyMain.vue?vue&type=script&lang=js&"
export * from "./HomeCompanyMain.vue?vue&type=script&lang=js&"
import style0 from "./HomeCompanyMain.vue?vue&type=style&index=0&id=dbf69f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf69f8e",
  null
  
)

export default component.exports